import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=3e6be355&"
import script from "./EventView.vue?vue&type=script&lang=js&"
export * from "./EventView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports